import { useContext } from "react"
import { WebAppContext } from "../providers/webapp-context"

export function useWebApp() {
  const context = useContext(WebAppContext)
  if (!context) {
    throw new Error("useWebApp must be used inside WebAppProvider")
  }
  return context
}
